import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { editTask } from "../../../../../store/plan/actions";
import { post } from "../../../../../actions/general";

import RhytSorting from "./loadable";

export default connect(null, { editTask, post })(injectIntl(RhytSorting as any));